import { useEffect, useState, FC, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AuthClient from "../api/AuthClient";
import GroupsClient from "../api/GroupsClient";
import { routes } from "../routes/routes";
import RefreshButton from "../components/RefreshToUpdateData/RefreshToUpdateButton";
import { PartiesContext } from "../GlobalContext/partiesContext";
import { LoadingAnimationContext } from "../GlobalContext/loadingAnimation";
import SortPartyGroupsByDate from "../SortPartyGroupsByDate";
import MyPartiesContent from "./MyPartiesContent";

interface MyPartiesProps {
  SetMyPartiesCount: (length: number) => void;
}
const MyParties: FC<MyPartiesProps> = ({ SetMyPartiesCount }) => {

  const authClient = useMemo(() => new AuthClient(), []);
  const isLoggedIn = authClient.isLoggedIn();

  const { myPartiesInfo, setMyPartiesInfoContextData } = useContext(PartiesContext);
  const { hasLoadedOnce, setHasLoadedOnce } = useContext(LoadingAnimationContext);

  const [refreshRequest, setRefreshRequest] = useState(false);
  const [requeststate, setRequestState] = useState('idle');
  const [isLoadingParties, setIsLoadingParties] = useState(!hasLoadedOnce);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(routes.Login);
    } else {
      if (!hasLoadedOnce || refreshRequest) {
        setIsLoadingParties(true);
        setRequestState('loading');

        const groupsClient: GroupsClient = new GroupsClient(authClient);
        groupsClient.getParsedMyParties().then((data) => {
          if (data) {
            if (data.data) {
              const sortedParties = SortPartyGroupsByDate(data.data);
              setMyPartiesInfoContextData(sortedParties);
            }
          }

          setHasLoadedOnce(true);
          setIsLoadingParties(false);
          setRequestState('idle');
          setRefreshRequest(false);
        }).catch((error) => {
          console.error("Error fetching my parties", error);
          setHasLoadedOnce(true);
          setIsLoadingParties(false);
          setRequestState('error');
          setRefreshRequest(false);
        });
      }
    }
  }, [authClient, hasLoadedOnce, isLoggedIn, navigate, refreshRequest, setHasLoadedOnce, setMyPartiesInfoContextData]);

  const handleButtonClick = () => {
    setRefreshRequest(true)
  };

  return (
    <>
      <div className="mb-3 refreshRequestContainer">
        <RefreshButton requestState={requeststate} onClickHandler={handleButtonClick} />
      </div>
      <MyPartiesContent
        isLoadingParties={isLoadingParties}
        myPartiesInfo={myPartiesInfo}
        SetMyPartiesCount={SetMyPartiesCount}
      />
    </>
  );
};

export default MyParties;

